import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const textBlockDefaultBlocks: BlockNode[] = [
  {
    id: 'tb-heading',
    type: 'text',
    content: { type: 'text', value: 'About Our Store', fontSize: 28, fontWeight: 700 },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'tb-body',
    type: 'text',
    content: { type: 'text', value: 'Tell your story here.', fontSize: 16, fontWeight: 400 },
    layout: { order: 1, widthPct: 100 },
  },
];

export const textBlockWidget = defineWidget({
  type: 'text-block',
  schema: {
    label: 'Text Block',
    description: 'Rich text content section with heading and body',
    props: {
      heading: {
        type: 'string',
        label: 'Heading',
      },
      body: {
        type: 'string',
        label: 'Body Text',
        default: '',
      },
      alignment: {
        type: 'enum',
        label: 'Text Alignment',
        options: ['left', 'center', 'right'],
        default: 'left',
      },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
      body: { type: 'text', label: 'Body Text' },
    },
    dataDeps: [],
  },
  nameTh: 'บล็อกข้อความ',
  descriptionTh: 'ส่วนเนื้อหาข้อความพร้อมหัวข้อและเนื้อหา',
  category: 'content',
  thumbnail: '/widget-thumbnails/text-block.svg',
  defaults: {
    type: 'text-block',
    props: { alignment: 'left' },
    slots: {
      heading: { value: 'About Our Store' },
      body: { value: 'Tell your story here.' },
    },
  },
  defaultBlocks: textBlockDefaultBlocks,
});
